/**
 * Banner persistente quando o backend está offline ou token inválido.
 * Não bloqueia a UI — só sinaliza.
 */
import { t } from "../i18n/index.js";

export default function ErrorBanner({ error, onOpenSettings }) {
  if (!error) return null;
  const hint = hintFor(error);
  return (
    <div className="mx-auto max-w-7xl px-4 mt-3">
      <div className="card border-noc-err/30 bg-noc-err/5 p-3 flex items-start gap-3">
        <div className="text-noc-err text-lg leading-none mt-0.5">⚠</div>
        <div className="flex-1 min-w-0">
          <div className="text-sm text-noc-text">
            <strong>{t("errors.backendCommFailed")}</strong>{" "}
            <span className="text-noc-muted">{error.message}</span>
          </div>
          {hint && (
            <div className="text-xs text-noc-muted mt-1">{hint}</div>
          )}
        </div>
        {onOpenSettings && (
          <button onClick={onOpenSettings} className="btn-ghost shrink-0">
            {t("errors.openSettings")}
          </button>
        )}
      </div>
    </div>
  );
}

function hintFor(err) {
  if (!err) return null;
  if (err.status === 0) return t("errors.hintNoConnection");
  if (err.status === 401) return t("errors.hintMissingToken");
  if (err.status === 403) return t("errors.hintInvalidToken");
  if (err.status === 404) return t("errors.hintNotFound");
  return null;
}
